import { useEffect, useState } from "react";
import {
  Box,
  Container,
  Divider,
  Grid,
  InputLabel,
  Link,
  makeStyles,
  Typography,
} from "@material-ui/core";
import { useNavigate, useSearchParams } from "react-router-dom";

import { PAGES } from "..";
import { SuccessModal } from "./SuccessModal";
import { LogoText } from "../../components/logoText";
import lockIcon from "../../assets/images/icons/lock.png";
import { FooterReset } from "../../components/footerReset";
import { Image, TextInput, Button } from "../../components/base";
import { AgreeTermCheck } from "../../components/agreeTermCheck";
import buildingImg from "../../assets/images/onboarding/buildingWithTree.svg";
import ResetPasswordImg from "../../assets/images/Registration/bottom_illustration.svg";
import { api, SPECIAL_CHARACTER, MIN_PASS_CHAR_COUNT, MAX_PASS_CHAR_COUNT } from "../../services";

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100vh",
  },
  logo: {
    padding: theme.spacing(5),
    textAlign: "center",
  },
  title: {
    marginTop: theme.spacing(12),
    marginBottom: theme.spacing(6),
    fontSize: "36px",
  },
  youremail: {
    marginLeft: "15%",
  },
  inputLabel: {
    fontSize: "14px",
    alignSelf: "left",
  },
  groupBtn: {
    marginTop: theme.spacing(6),
  },
  resetImgstyle: {
    display: "flex",
    justifyContent: "center",
    position: "relative",
    top: "107px",
    marginTop: "0.8%",
  },
  welcomeTitle: {
    fontSize: 42,
    marginBottom: theme.spacing(2),
  },
  letGoBtn: {
    width: "fit-content",
    marginTop: theme.spacing(6),
  },
}));

export const ResetPasswordPage = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [username, email] = [params.get("username"), params.get("email")];

  const [errors, setErrors] = useState({});
  const [isopen, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [password, setPassword] = useState("");
  const [rePassword, setRePassword] = useState("");
  const [url, setUrl] = useState({
    token: "",
    uid: "",
  });
  const [agree, setAgree] = useState(true);

  useEffect(() => {
    localStorage.clear();
  }, []);

  const handleReset = () => {
    setErrors({});
    const errors = {};
    if (!(password === rePassword)) {
      errors["rePassword"] = "Password Does Not Match";
    }
    if (!SPECIAL_CHARACTER.test(password)) {
      errors["password"] = "Password Should Contain Special Character";
    }
    if (!(password.length >= MIN_PASS_CHAR_COUNT && password.length <= MAX_PASS_CHAR_COUNT)) {
      errors["password"] = "Password should contain 8-20 characters";
    }
    if (!password) {
      errors["password"] = "Please enter Password";
    }
    if (!rePassword) {
      errors["rePassword"] = "Please Re-Enter Your Password";
    }
    if (username && !agree) {
      errors["agree"] = true;
    }
    setErrors(errors);
    if (Object.keys(errors).length > 0) {
      return;
    }
    setLoading(true);
    api
      .post("/auth/change-pass/", {
        token: url.token,
        uid: url.uid,
        password: password,
      })
      .then((res) => {
        if (res.status === 200) {
          setOpen(true);
        }
      })
      .catch((err) => console.log(err))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    const params = new URL(window.location.href).searchParams;
    const uid = params.get("uid");
    const token = params.get("token").slice(0, -1);
    setUrl({
      token: token,
      uid: uid,
    });
  }, []);

  return (
    <div className={classes.root}>
      <div className={classes.logo}>
        <LogoText />
      </div>
      <Divider />
      {username ? (
        <Box display="flex" justifyContent="center" alignItems="center" my={8}>
          <Image src={buildingImg} width={120} />
          <Box ml={4}>
            <Typography className={classes.welcomeTitle} variant="h1">
              Welcome, {username}!
            </Typography>
            <Typography variant="h4">Let’s begin the adventure. Sign up to continue</Typography>
          </Box>
        </Box>
      ) : (
        <Typography className={classes.title} variant="h4" align="center">
          Reset Password
        </Typography>
      )}

      <Container style={{ maxWidth: 300 }}>
        <Grid container direction="column">
          {username ? (
            <Box mb={1.5} width="200%">
              <Typography>
                You’re signing up as <b>{email}</b>; Complete password to continue
              </Typography>
            </Box>
          ) : (
            <InputLabel className={classes.inputLabel}>Your password:</InputLabel>
          )}

          <TextInput
            id="password-input"
            type="password"
            fullWidth
            placeHolder={username ? "Define Password" : "password"}
            onChange={(e) => setPassword(e)}
            value={password}
            error={errors.password}
            onFocus={() => setErrors({ ...errors, password: null })}
            startAdornment={<img src={lockIcon} alt="lock-icon" />}
          />

          <TextInput
            id="password-input"
            type="password"
            fullWidth
            placeHolder={username ? "Re-enter Password" : "Re-enter new password"}
            onChange={(e) => setRePassword(e)}
            value={rePassword}
            error={errors.rePassword}
            onFocus={() => setErrors({ ...errors, password: null })}
            startAdornment={<img src={lockIcon} alt="lock-icon" />}
          />

          {username ? (
            <>
              <AgreeTermCheck agree={agree} setAgree={setAgree} error={errors.agree} />
              <Button
                rootStyle={classes.letGoBtn}
                text="Let’s go!"
                onClick={handleReset}
                loading={loading}
              />
              <Box mt={8}>
                Already have an account? <Link href={PAGES.login}>Sign in</Link> instead.
              </Box>
            </>
          ) : (
            <Grid
              className={classes.groupBtn}
              container
              justifyContent="space-evenly"
              alignItems="center"
            >
              <Button text="RESET PASSWORD" loading={loading} onClick={handleReset} />
            </Grid>
          )}
        </Grid>
      </Container>
      {!username && (
        <div>
          <div className={classes.resetImgstyle}>
            <img src={ResetPasswordImg} alt="" />
          </div>
          <div>
            <FooterReset />
          </div>
        </div>
      )}

      <SuccessModal isOpen={isopen} setOpen={setOpen} navigate={navigate} />
    </div>
  );
};
